import React, { useState } from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function HourlyForecast({
  currentLocation,
  locationName,
  input,
  inputCountry,
}) {
  console.log("hourly");

  var timezone = currentLocation.timezone;

  const data = currentLocation.hourly.slice(0, 10);
  const TimeFunction = (data) => {
    console.log("time", timezone);
    return new Date(data * 1000).toLocaleString("en", {
      timeZone: `${timezone}`,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const tempFunction = (data) => {
    return `${data}°C`;
  };
  const dates = currentLocation.hourly.map((data) => TimeFunction(data.dt));

  const temp = currentLocation.hourly.map((data) => data.temp);
  // console.log("dates", dates);

  // console.log("temp", temp);

  let dateTempArrayOfObject = dates.map(function (value, index) {
    return [value, temp[index]];
  });
  const slicedData = dateTempArrayOfObject.slice(0, 14);
  // console.log("dateTempArrayOfObject");
  return (
    <>
      <div className="mt-5">
        <h4 className="primary-color">
          Hourly Forecast in{" "}
          {input && input ? input : locationName && locationName.city},
          {inputCountry && inputCountry
            ? inputCountry
            : locationName && locationName.country_code}
        </h4>
      </div>
      <div className="mt-4 hourly-chart hourly-bg-container">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={800}
            height={300}
            data={slicedData}
            margin={{
              top: 35,
              right: 50,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="0" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="1"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}

export default HourlyForecast;
